/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiaryMetricIntervalDto } from './diaryMetricIntervalDto';
import { DiaryMetricDetailsDto } from './diaryMetricDetailsDto';
import { DiaryMetricComparisonDto } from './diaryMetricComparisonDto';
import { DiaryMetricView } from './diaryMetricView';


export interface DiaryMetricDto { 
    view?: DiaryMetricView;
    total?: number;
    target?: number;
    targetPercentage?: number | null;
    intervals?: Array<DiaryMetricIntervalDto> | null;
    previous?: DiaryMetricComparisonDto;
    diaryMetricDetails?: DiaryMetricDetailsDto;
}
export namespace DiaryMetricDto {
}


